import { FC } from 'react';
import { useMethods } from '@lhb/hook';
import { setSession } from '@lhb/cache';
import { youthMapDrawerRangeCode } from '../FirstScreenRight/ts-config';
import { useBigdataFn } from '@/common/utils/bigdata';
import { useYouthMapDistance } from './useYouthMapDistance';
import styles from './index.module.less';
import { Select } from 'antd';

/**
 * 商圈详情-人口数据的显示范围/显示距离下拉框
 */
const RangeSelect:FC<{
  /** 显示范围/显示距离，这里是id，如 5、10 */
  rangeType,
  /** 更新显示范围/显示距离 */
  setRangeType,
  /** 模型配置id */
  modelConfigId,
  /** 分享时调用接口需要的数据，如果有值代表“分享时” */
  shareData?: { tenantId, userId } | null,
}> = ({
  rangeType,
  setRangeType,
  modelConfigId,
  shareData,
}) => {

  /* state */
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook

  /* hooks */
  /** 距离选项，这里以 id 作为 key */
  const { distances } = useYouthMapDistance({
    modelConfigId,
    shareData: shareData ? { tenantId: shareData.tenantId, userId: shareData.userId } : null,
    options: {
      // autoFetch: false,
      onSuccess: (options) => {
        methods.getYouthMapDistance(options);
      }
    }
  });
  const options = (Array.isArray(distances) ? distances : []).map(item => ({
    ...item,
    label: item.shortName || item.label
  }));

  const methods = useMethods({

    getYouthMapDistance(data) {
      // 如果缓存的选中距离不在选项内，则按照下面逻辑赋予默认值
      // 暂时不取缓存，默认选中配置最小的距离；如果没有，则取第一项；选项是从小到大排好的
      if (Array.isArray(data) && data.length) {
        const item = data.find(item => item.tenantConfig) || data[0];
        methods.selectValue(item?.value);
      }
    },

    /** 选中后处理 */
    selectValue(val) {
      // 如果当前选中与选项一致则不处理
      if (rangeType === val) {
        return;
      }
      setRangeType(val);
      setSession(youthMapDrawerRangeCode, val); // 缓存距离
      bigdataFn('0895baaa-8a06-4dc4-8ee2-f9f3fa7b3949',
        '详情页-选择范围',
        '点击了详情页-选择范围',
        { op_event: `选择的距离${val}`, });
    },

    // 距离选择下拉框改变
    onChange: (value) => {
      methods.selectValue(value);
    },

  });

  return (
    <div className={styles.rangeSelect}>
      <Select
        className={styles.select}
        options={options}
        allowClear={false}
        placeholder='选择显示范围'
        value={rangeType}
        onChange={methods.onChange}
        // 兼容全屏
        getPopupContainer= {(node) => node.parentNode}
      />
    </div>
  );
};
export default RangeSelect;
